module.exports = __webpack_public_path__ + "static/1975-7bb6ae687da4933b709797e552047780.webp";